'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["illustrationName", "children"];
import PropTypes from 'prop-types';
import styled from 'styled-components';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import UIIllustration from 'UIComponents/image/UIIllustration';
import useMediaQuery from 'LearningCenterUI/hooks/useMediaQuery';
import { device } from '../../../constants/StyledComponentConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InnerWrapperUIFlex = styled(UIFlex).withConfig({
  displayName: "PracticalExerciseProgressFeedback__InnerWrapperUIFlex",
  componentId: "bgof8k-0"
})(["min-height:412px;width:100%;@media screen and ", "{min-height:unset;}"], device.mobile);
const PracticalExerciseProgressFeedback = _ref => {
  let {
      illustrationName,
      children
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const isMobile = useMediaQuery(`screen and ${device.mobile}`);
  return /*#__PURE__*/_jsxs(InnerWrapperUIFlex, Object.assign({
    align: "center",
    direction: isMobile ? 'column' : 'row',
    justify: "center"
  }, restProps, {
    children: [/*#__PURE__*/_jsx(UIBox, {
      basis: !isMobile ? '50%' : 'auto',
      children: /*#__PURE__*/_jsx(UIFlex, {
        justify: "end",
        children: /*#__PURE__*/_jsx(UIIllustration, {
          className: isMobile ? 'm-bottom-4' : 'm-right-13',
          name: illustrationName,
          width: "150px"
        })
      })
    }), /*#__PURE__*/_jsx(UIBox, {
      basis: !isMobile ? '50%' : 'auto',
      style: !isMobile ? {
        paddingRight: '100px'
      } : {},
      children: children
    })]
  }));
};
PracticalExerciseProgressFeedback.propTypes = {
  children: PropTypes.node.isRequired,
  illustrationName: PropTypes.string.isRequired
};
export default PracticalExerciseProgressFeedback;